export function timeline() {

  console.log("TIMELINE INIT");

  const wrappers = document.querySelectorAll(".timeline-wrapper");
  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {

    const items = wrapper.querySelectorAll(".item");
    const image = wrapper.querySelector(".timeline-image");
    const subtitle = wrapper.querySelector(".article__widget_subtitle");
    const prevBtn = wrapper.querySelector(".timeline-arrow.prev");
    const nextBtn = wrapper.querySelector(".timeline-arrow.next");
    const container = wrapper.querySelector(".image-container");

    if (!items.length || !image || !container) return;

    let currentIndex = [...items].findIndex(el =>
      el.classList.contains("active")
    );

    if (currentIndex === -1) currentIndex = 0;

    function swapImage(url) {
      image.classList.add("is-out");

      setTimeout(() => {
        image.src = url;

        requestAnimationFrame(() => {
          image.classList.remove("is-out");
        });

      }, 180);
    }

    function setActive(index) {
      if (index < 0 || index >= items.length) return;

      items.forEach(el => el.classList.remove("active"));
      items[index].classList.add("active");

      const item = items[index];

      swapImage(item.dataset.img);

      if (subtitle) {
        subtitle.textContent = item.dataset.text || "";
      }

      currentIndex = index;
      updateArrows();
    }

    items.forEach((item, index) => {
      item.addEventListener("click", () => {
        setActive(index);
      });
    });

    function updateArrows() {
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex === items.length - 1;
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", () => {
        setActive(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        setActive(currentIndex + 1);
      });
    }

    let startX = 0;
    let isSwiping = false;

    container.addEventListener("mousedown", (e) => {
      startX = e.clientX;
      isSwiping = true;
    });

    window.addEventListener("mouseup", (e) => {
      if (!isSwiping) return;

      const diff = startX - e.clientX;
      isSwiping = false;

      if (Math.abs(diff) < 30) return;

      if (diff > 0) {
        setActive(currentIndex + 1);
      } else {
        setActive(currentIndex - 1);
      }
    });

    container.addEventListener("touchstart", (e) => {
      startX = e.touches[0].clientX;
      isSwiping = true;
    }, { passive: true });

    window.addEventListener("touchend", (e) => {
      if (!isSwiping) return;

      const diff = startX - e.changedTouches[0].clientX;
      isSwiping = false;

      if (Math.abs(diff) < 30) return;

      if (diff > 0) {
        setActive(currentIndex + 1);
      } else {
        setActive(currentIndex - 1);
      }
    });

    container.style.touchAction = "pan-y";
    container.style.userSelect = "none";

    setActive(currentIndex);
    updateArrows();

  });
}